// jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });
  
// });

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector))
        }
  
        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector))
                observer.disconnect()
            }
        })
  
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    })
}

if (location.pathname.indexOf('/products/') !== -1) {
	waitForElm(`[data-sticky-addtocart] [bl-data-action-atc]`).then((el) => {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			document.querySelector(`.t4s-form__product [data-atc-form]`).click();
		});
	});
}